import { render, staticRenderFns } from "./NoResultBox.vue?vue&type=template&id=671c8396&scoped=true&"
import script from "./NoResultBox.vue?vue&type=script&lang=js&"
export * from "./NoResultBox.vue?vue&type=script&lang=js&"
import style0 from "./NoResultBox.vue?vue&type=style&index=0&id=671c8396&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671c8396",
  null
  
)

export default component.exports